export default {
  SET_GRADES(state, grades) {
    state.grades = grades
  },
  REMOVE_GRADE(state, itemId) {
      const gradeIndex = state.grades.datas.findIndex((u) => u.id == itemId)
      state.grades.datas.splice(gradeIndex, 1)
  },
  SELECTED_GRADE(state,data){
    state.grades.datas = []
    state.grades.total = 1;
    state.grades.per_page = 1;
    state.grades.datas.push(data)
  },
  SET_AUTOCOMPLETE_DATA(state,data){
    state.autocomplete_data = data
  },
  EDIT_ITEM(state,data){
    state.elomark_user = data
  },
  ADD_ITEM(state,data){
    state.elomark_user = data
  },
}
